// import "./update.scss";
// import Select from "react-select";
// import Sidebar from "../sidebar/Sidebar";
// import Navbar from "../navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { examinationInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// const DurationOptions = [
//   { value: "3hr", label: "3hr" },
//   { value: "2hr", label: "2hr" },
//   { value: "1hr", label: "1hr" },
// ];

// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];
// const cstatusOptions = [
//   { value: "Done", label: "Done" },
//   { value: "Not Done", label: "Not Done" },
// ];
// const PaperOptions = [
//   { value: "Monthly", label: "Monthly" },
//   { value: "Module-1", label: "Module-1" },
//   { value: "Module-2", label: "Module-2" },
//   { value: "Module-3", label: "Module-3" },
//   { value: "Mock", label: "Mock" },
//   { value: "Preliam", label: "Preliam" },
// ];

// const ExaminationUpdate = ({ title }) => {
//   // Extracting examinationId using regular expressions
//   const location = useLocation();
//   const examinationId = location.pathname.match(
//     /\/update-examination\/(\d+)/
//   )?.[1];

//   // Initializing state
//   const [file, setFile] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedDuration, setSelectedDuration] = useState(null);
//   const [selectedCstatus, setSelectedCstatus] = useState(null);
//   const [selectedPtype, setSelectedPtype] = useState(null);
//   const [selectedClass, setSelectedClass] = useState(null);
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [coption, setCoption] = useState([]);
//   const [soption, setSoption] = useState([]);
//   const [uoption, setUoption] = useState([]);
//   const center_id = localStorage.getItem("center_id");
//   const [inputValues, setInputValues] = useState("");

//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchExamination = async () => {
//       try {
//         const response = await fetch(
//           `${serverUrl}/examination/${examinationId}`,
//           {
//             method: "GET",
//           }
//         );
//         if (!response.ok) {
//           throw new Error("Failed to fetch quiz");
//         }
//         const data = await response.json();
//         console.log("abbas", data);
//         const rawDate = data.data.date; // e.g., "Mon, 05 May 2025 00:00:00 GMT"
//         const formattedDate = new Date(rawDate).toISOString().split("T")[0]; // Output: "2025-05-05"

//         setInputValues({
//           ...data.data,
//           date: formattedDate,
//         });
//         setSelectedClass({
//           value: data.data.class_id,
//           label: data.data.class_names,
//         });
//         setSelectedSubject({
//           value: data.data.subject_id,
//           label: data.data.subject_names,
//         });
//         setSelectedUser({
//           value: data.data.user_id,
//           label: data.data.user_names,
//         });
//         // console.log("quiz in a state:", data.data.file);
//         const status = data.data.status;
//         if (status == 1) {
//           setSelectedStatus({ value: status, label: "Active" });
//         } else {
//           setSelectedStatus({ value: status, label: "Inactive" });
//         }
//         const duration = data.data.duration;
//         if (duration == "3hr") {
//           setSelectedDuration({ value: duration, label: "3hr" });
//         } else if (duration == "2hr") {
//           setSelectedDuration({ value: duration, label: "2hr" });
//         } else {
//           setSelectedDuration({ value: duration, label: "1hr" });
//         }
//         const checking_status = data.data.checking_status;
//         if (checking_status == "Done") {
//           setSelectedCstatus({ value: checking_status, label: "Done" });
//         } else {
//           setSelectedCstatus({ value: checking_status, label: "Not Done" });
//         }
//         const type = data.data.type;
//         if (type == "Monthly") {
//           setSelectedPtype({ value: type, label: "Monthly" });
//         } else if (type == "Module-1") {
//           setSelectedPtype({ value: type, label: "Module-1" });
//         } else if (type == "Module-2") {
//           setSelectedPtype({ value: type, label: "Module-2" });
//         } else if (type == "Module-3") {
//           setSelectedPtype({ value: type, label: "Module-3" });
//         } else if (type == "Mock") {
//           setSelectedPtype({ value: type, label: "Mock" });
//         } else {
//           setSelectedPtype({ value: type, label: "Preliam" });
//         }
//         setFile(data.data.file_url);
//         localStorage.setItem("quizData", JSON.stringify(data));
//       } catch (error) {
//         console.error(error);
//       }
//     };
//     console.log("quiz in the a state:", file);
//     if (examinationId) {
//       fetchExamination();
//     }
//   }, [examinationId]);
//   // console.log("quiz in a state:", data);

//   const handleClassSelectChange = (selectedOption) => {
//     setSelectedClass(selectedOption);
//     setInputValues({
//       ...inputValues,
//       class_id: selectedOption.value,
//     });
//   };

//   useEffect(() => {
//     class_name();
//   }, []); // Empty dependency array means it runs once when the component mounts
//   const class_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         if (selectedClass == id) {
//           setSelectedClass({ value: id, label: name });
//         }
//         namelist.push({ value: id, label: name });
//       }
//       console.log(selectedClass);
//       console.log(namelist);
//       setCoption(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleSubjectSelectChange = (selectedOption) => {
//     setSelectedSubject(selectedOption);
//     setInputValues({
//       ...inputValues,
//       subject_id: selectedOption.value,
//     });
//   };

//   useEffect(() => {
//     subject_name();
//   }, []); // Empty dependency array means it runs once when the component mounts
//   const subject_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         if (selectedSubject == id) {
//           setSelectedSubject({ value: id, label: name });
//         }
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setSoption(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleUserSelectChange = (selectedOption) => {
//     setSelectedUser(selectedOption);
//     setInputValues({
//       ...inputValues,
//       user_id: selectedOption.value,
//     });
//   };

//   useEffect(() => {
//     user_name();
//   }, []); // Empty dependency array means it runs once when the component mounts
//   const user_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         if (selectedUser == id) {
//           setSelectedUser({ value: id, label: name });
//         }
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setUoption(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//     console.log(e);
//   };

//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };

//   const handleCstatusSelectChange = (selectedOption) => {
//     setSelectedCstatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       checking_status: selectedOption.value,
//     });
//   };

//   const handlePtypeSelectChange = (selectedOption) => {
//     setSelectedPtype(selectedOption);
//     setInputValues({
//       ...inputValues,
//       type: selectedOption.value,
//     });
//   };

//   const handleDurationSelectChange = (selectedOption) => {
//     setSelectedDuration(selectedOption);
//     setInputValues({
//       ...inputValues,
//       duration: selectedOption.value,
//     });
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     // const formData = {
//     //     id: examinationId,
//     //     center_id: inputValues.cen_id,
//     //     class_id: inputValues.class_id,
//     //     subject_id: inputValues.subject_id,
//     //     type: inputValues.type,
//     //     month: inputValues.month,
//     //     date: inputValues.date,
//     //     total_marks: inputValues.total_marks,
//     //     user_id: inputValues.user_id,
//     //     schedule_start_time: inputValues.schedule_start_time,
//     //     schedule_end_time: inputValues.schedule_end_time,
//     //     start_time: inputValues.start_time,
//     //     end_time: inputValues.end_time,
//     //     checking_status: inputValues.checking_status,
//     //     logo: file || "",
//     //     status: parseInt(inputValues.status),
//     // };
//     // console.log("Abbas",formData)

//     const formData = new FormData();
//     formData.append("id", examinationId);
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("class_id", inputValues.class_id);
//     formData.append("subject_id", inputValues.subject_id);
//     formData.append("type", inputValues.type);
//     formData.append("month", inputValues.month);
//     formData.append("date", inputValues.date);
//     formData.append("total_marks", inputValues.total_marks);
//     formData.append("user_id", inputValues.user_id);
//     formData.append("schedule_start_time", inputValues.schedule_start_time);
//     formData.append("schedule_end_time", inputValues.schedule_end_time);
//     formData.append("start_time", inputValues.start_time);
//     formData.append("end_time", inputValues.end_time);
//     formData.append("duration", inputValues.duration);
//     formData.append("checking_status", inputValues.checking_status);
//     formData.append("file", file || "");
//     formData.append("status", parseInt(inputValues.status));
//     console.log(formData);

//     // Send formData to the server using an HTTP request to update
//     fetch(`${serverUrl}/upd_examination/${examinationId}`, {
//       method: "PUT",
//       body: formData, // Pass the object as the body
//     })
//       .then((response) => {
//         return response.json();
//       })
//       .then((data) => {
//         if (data.code >= 400) {
//           if (typeof data.message === "object") {
//             Object.entries(data.message).forEach(([field, errors]) => {
//               errors.forEach((errMsg) => {
//                 toast.error(`${field}: ${errMsg}`);
//               });
//             });
//           } else {
//             toast.error(data.message || "Something went wrong.");
//           }

//           // setFilteredOptions(options); // Reset available roles

//           // Force the component to rerender with the empty state
//           setTimeout(() => {}, 500); // Adding timeout to allow state change
//         } else {
//           toast.success("Examination updated successfully!");
//           setTimeout(() => {
//             navigate("/examinations");
//           }, 1000);
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="left">
//                 {file &&
//                 typeof file === "string" &&
//                 file.toLowerCase().endsWith(".pdf") ? (
//                   <img
//                     src="/images/pdf_icon.png"
//                     alt="Bform PDF"
//                     className="itemImg"
//                   />
//                 ) : file &&
//                   typeof file === "object" &&
//                   file.type &&
//                   file.type.startsWith("image/") ? (
//                   <img
//                     src={URL.createObjectURL(file)}
//                     alt="Bform Preview"
//                     className="itemImg"
//                   />
//                 ) : (
//                   <img
//                     src={
//                       typeof file === "string"
//                         ? file
//                         : "/images/upload_file.png"
//                     }
//                     alt="Default Bform"
//                     className="itemImg"
//                   />
//                 )}
//               </div>
//               <div className="right">
//                 <form onSubmit={handleUpdate}>
//                   <div className="formInput">
//                     <label htmlFor="file">
//                       Image: <DriveFolderUploadOutlinedIcon className="icon" />
//                     </label>
//                     <input
//                       type="file"
//                       id="file"
//                       accept="image/*,.pdf"
//                       onChange={(e) => setFile(e.target.files[0])}
//                       style={{ display: "none" }}
//                     />
//                   </div>
//                   {examinationInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "user_id" ? (
//                         <Select
//                           options={uoption}
//                           name={input.fieldName}
//                           value={selectedUser}
//                           onChange={handleUserSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "subject_id" ? (
//                         <Select
//                           options={soption}
//                           name={input.fieldName}
//                           value={selectedSubject}
//                           onChange={handleSubjectSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "class_id" ? (
//                         <Select
//                           options={coption}
//                           name={input.fieldName}
//                           value={selectedClass}
//                           onChange={handleClassSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "status" ? (
//                         <Select
//                           options={statusOptions}
//                           name={input.fieldName}
//                           value={selectedStatus}
//                           onChange={handleStatusSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "checking_status" ? (
//                         <Select
//                           options={cstatusOptions}
//                           name={input.fieldName}
//                           value={selectedCstatus}
//                           onChange={handleCstatusSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "type" ? (
//                         <Select
//                           options={PaperOptions}
//                           name={input.fieldName}
//                           value={selectedPtype}
//                           onChange={handlePtypeSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "duration" ? (
//                         <Select
//                           options={DurationOptions}
//                           name={input.fieldName}
//                           value={selectedDuration}
//                           onChange={handleDurationSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required
//                           // inputMode={input.fieldName === 'no_of_quiz' ? 'numeric' : undefined}
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formUpdate">
//                     <button
//                       style={{ float: "right" }}
//                       // onClick={() => navigate(`/categories`)}
//                     >
//                       Update
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       type="button"
//                       style={{ float: "right" }}
//                       onClick={() => navigate(`/examinations`)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default ExaminationUpdate;

import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../sidebar/Sidebar";
import Navbar from "../navbar/Navbar";
import { examinationInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const durationOptions = [
  { value: "3hr", label: "3hr" },
  { value: "2hr", label: "2hr" },
  { value: "1hr", label: "1hr" },
];

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const checkingStatusOptions = [
  { value: "Done", label: "Done" },
  { value: "Not Done", label: "Not Done" },
];

const paperTypeOptions = [
  { value: "Monthly", label: "Monthly" },
  { value: "Module-1", label: "Module-1" },
  { value: "Module-2", label: "Module-2" },
  { value: "Module-3", label: "Module-3" },
  { value: "Mock", label: "Mock" },
  { value: "Preliam", label: "Preliam" },
];

const ExaminationUpdate = ({ title }) => {
  const location = useLocation();
  const examinationId = location.pathname.match(
    /\/update-examination\/(\d+)/,
  )?.[1];
  const centerId = localStorage.getItem("center_id");
  const navigate = useNavigate();

  const [file, setFile] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedDuration, setSelectedDuration] = useState(null);
  const [selectedCheckingStatus, setSelectedCheckingStatus] = useState(null);
  const [selectedPaperType, setSelectedPaperType] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [classOptions, setClassOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please login first to access this page");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchExamination = async () => {
      try {
        const response = await fetch(
          `${serverUrl}/examination/${examinationId}`,
        );
        if (!response.ok) throw new Error("Failed to fetch examination data");
        const data = await response.json();

        const rawDate = data.data.date;
        const formattedDate = new Date(rawDate).toISOString().split("T")[0];

        setInputValues({
          ...data.data,
          date: formattedDate,
        });

        setSelectedClass({
          value: data.data.class_id,
          label: data.data.class_names,
        });

        setSelectedSubject({
          value: data.data.subject_id,
          label: data.data.subject_names,
        });

        setSelectedUser({
          value: data.data.user_id,
          label: data.data.user_names,
        });

        setSelectedStatus(
          data.data.status === 1
            ? { value: 1, label: "Active" }
            : { value: 0, label: "Inactive" },
        );

        setSelectedDuration({
          value: data.data.duration,
          label: data.data.duration,
        });

        setSelectedCheckingStatus({
          value: data.data.checking_status,
          label: data.data.checking_status,
        });

        setSelectedPaperType({
          value: data.data.type,
          label: data.data.type,
        });

        setFile(data.data.file_url);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch examination data");
      }
    };

    if (examinationId) fetchExamination();
  }, [examinationId]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        // Fetch classes
        const classesRes = await fetch(`${serverUrl}/class_ids_dp/${centerId}`);
        const classesData = await classesRes.json();
        setClassOptions(
          classesData.data.map((c) => ({ value: c.id, label: c.name })),
        );

        // Fetch subjects
        const subjectsRes = await fetch(`${serverUrl}/subject_ids/${centerId}`);
        const subjectsData = await subjectsRes.json();
        setSubjectOptions(
          subjectsData.data.map((s) => ({ value: s.id, label: s.name })),
        );

        // Fetch users
        const usersRes = await fetch(`${serverUrl}/user_ids/${centerId}`);
        const usersData = await usersRes.json();
        setUserOptions(
          usersData.data.map((u) => ({ value: u.id, label: u.name })),
        );
      } catch (error) {
        console.error("Error fetching options:", error);
        toast.error("Failed to load options");
      }
    };

    fetchOptions();
  }, [centerId]);

  const handleSelectChange = (field, selectedOption) => {
    const setters = {
      status: setSelectedStatus,
      duration: setSelectedDuration,
      checking_status: setSelectedCheckingStatus,
      type: setSelectedPaperType,
      class_id: setSelectedClass,
      subject_id: setSelectedSubject,
      user_id: setSelectedUser,
    };

    setters[field](selectedOption);
    setInputValues({
      ...inputValues,
      [field]: selectedOption.value,
    });
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const renderFilePreview = () => {
    if (file instanceof File) {
      if (file.type.startsWith("image/")) {
        return (
          <img
            src={URL.createObjectURL(file)}
            alt="Preview"
            className="filePreviewImg"
          />
        );
      }
      return (
        <img src="/images/pdf_icon.png" alt="PDF" className="filePreviewImg" />
      );
    } else if (typeof file === "string") {
      if (file.toLowerCase().endsWith(".pdf")) {
        return (
          <img
            src="/images/pdf_icon.png"
            alt="PDF"
            className="filePreviewImg"
          />
        );
      }
      return (
        <img
          src={file || "/images/upload_file.png"}
          alt="Preview"
          className="filePreviewImg"
        />
      );
    }
    return (
      <img
        src="/images/upload_file.png"
        alt="Default"
        className="filePreviewImg"
      />
    );
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    if (file instanceof File) formData.append("file", file);

    // Only include fields that should be sent to the backend
    const fieldsToSend = [
      "center_id",
      "class_id",
      "subject_id",
      "type",
      "month",
      "date",
      "total_marks",
      "user_id",
      "schedule_start_time",
      "schedule_end_time",
      "start_time",
      "end_time",
      "checking_status",
      "status",
      "duration",
    ];

    fieldsToSend.forEach((field) => {
      if (inputValues[field] !== undefined && inputValues[field] !== null) {
        formData.append(field, inputValues[field]);
      }
    });

    try {
      const response = await fetch(
        `${serverUrl}/upd_examination/${examinationId}`,
        {
          method: "PUT",
          body: formData,
        },
      );

      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => toast.error(`${field}: ${errMsg}`));
          });
        } else {
          toast.error(data.message || "Update failed");
        }
      } else {
        toast.success("Examination updated successfully!");
        setTimeout(() => navigate("/examinations"), 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    }
  };

  const renderSelectField = (field, options, value) => (
    <Select
      options={options}
      value={value}
      onChange={(option) => handleSelectChange(field, option)}
      required
      className="selectInput"
      styles={{
        control: (base) => ({
          ...base,
          minHeight: "46px",
          borderColor: "#e2e8f0",
          "&:hover": { borderColor: "#cbd5e0" },
        }),
        valueContainer: (base) => ({
          ...base,
          padding: "2px 8px",
        }),
        input: (base) => ({
          ...base,
          margin: "0",
          padding: "0",
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: "44px",
        }),
      }}
    />
  );

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>

                  <div className="filePreviewGrid">
                    <div className="filePreviewItem">
                      <label className="filePreviewLabel">
                        Examination File
                      </label>
                      <div className="filePreviewBox">
                        {renderFilePreview()}
                        <label htmlFor="file" className="fileUploadBtn">
                          <DriveFolderUploadOutlinedIcon className="icon" />
                          <span>Upload File</span>
                        </label>
                        <input
                          type="file"
                          id="file"
                          accept="image/*,.pdf"
                          onChange={(e) => setFile(e.target.files[0])}
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                  </div>

                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      {examinationInputs.map((input) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          key={input.id}
                          className="formGridItem"
                        >
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "class_id" ? (
                              renderSelectField(
                                "class_id",
                                classOptions,
                                selectedClass,
                              )
                            ) : input.fieldName === "subject_id" ? (
                              renderSelectField(
                                "subject_id",
                                subjectOptions,
                                selectedSubject,
                              )
                            ) : input.fieldName === "user_id" ? (
                              renderSelectField(
                                "user_id",
                                userOptions,
                                selectedUser,
                              )
                            ) : input.fieldName === "status" ? (
                              renderSelectField(
                                "status",
                                statusOptions,
                                selectedStatus,
                              )
                            ) : input.fieldName === "duration" ? (
                              renderSelectField(
                                "duration",
                                durationOptions,
                                selectedDuration,
                              )
                            ) : input.fieldName === "checking_status" ? (
                              renderSelectField(
                                "checking_status",
                                checkingStatusOptions,
                                selectedCheckingStatus,
                              )
                            ) : input.fieldName === "type" ? (
                              renderSelectField(
                                "type",
                                paperTypeOptions,
                                selectedPaperType,
                              )
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/examinations")}
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                      >
                        Update Examination
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default ExaminationUpdate;
